import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import { IMailerApi } from './types';

export const mailer: IMailerApi = {
  sendEmail: (payload) =>
    http.post(endpoint.mailer.SEND_EMAIL, payload).then((response) => response.data),
};
